import { InjectionToken } from '@angular/core';

export const ROOT_COMPONENTS = new InjectionToken('@digitaix/core/component/ROOT_COMPONENTS');
export const FEATURE_COMPONENTS = new InjectionToken('@digitaix/core/component/FEATURE_COMPONENTS');

export const COMPONENT_DEFINITION = new InjectionToken('@digitaix/core/component/COMPONENT_DEFINITION');
